import angular from 'angular';
import UserDataService from './userData.service';
import ManagerDataService from './managerData.service';
import HolidayTypesService from './autoservicesDictionary.service';
import AuthenticationService from './authentication.service';
import ManagerForEmployeeService from './managerForEmployee.service';
import DelegationService from './delegations.service';
import ManagerNavigation from './managerNavigation.service';
import StatusAppCheckers from './statusAppCheckers.service';
import cookieService from './cookie.service';
import HelperDelegationsService from './helperDelegations.service';
import visitedStatesService from './visitedStates.service';
import visitedPagesService from './visitedPages.service';
import loadingMobileService from './loading.mobile.service';
import NetworkService from './network.service';

let serviceModule = angular

  .module('common.services', [])

  .service('UserDataService', UserDataService)
  .service('ManagerDataService', ManagerDataService)
  .service('AppDictionary', HolidayTypesService)
  .service('AuthenticationService', AuthenticationService)
  .service('ManagerForEmployeeService', ManagerForEmployeeService)
  .service('DelegationService', DelegationService)
  .service('ManagerNavigationService', ManagerNavigation)
  .service('StatusAppCheckers', StatusAppCheckers)
  .service('cookieService', cookieService)
  .service('HelperDelegationsService', HelperDelegationsService)
  .service('visitedStatesService', visitedStatesService)
  .service('visitedPagesService', visitedPagesService)
  .service('loadingMobileService', loadingMobileService)
  .service('networkService', NetworkService)

  .name;

export default serviceModule;



// WEBPACK FOOTER //
// ./client/app/common/services/services.js